import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/paramount/paramount/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "paramount"
    }}>{`Paramount`}</h1>
    <p><a parentName="p" {...{
        "href": "https://travis-ci.org/WeTrustPlatform/paramount.svg?branch=master"
      }}><img alt="Build Status" src="https://travis-ci.org/WeTrustPlatform/paramount.svg?branch=master" /></a>{`
`}<img alt="npm" src="https://img.shields.io/npm/v/paramount-ui.svg" />{` `}<img alt="GitHub" src="https://img.shields.io/github/license/wetrustplatform/paramount.svg" /></p>
    <p>{`Paramount UI is a React components library. The core features of this library is`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Cross platform.`}</strong>{` Components work and look the same on Web, iOS, Android and Desktop apps`}</li>
      <li parentName="ul"><strong parentName="li">{`Customizable.`}</strong>{` The theming and components are highly customizable, so that you can adapt to your branding needs.`}</li>
      <li parentName="ul"><strong parentName="li">{`35+ components.`}</strong>{` Building blocks from buttons to responsive layout and icons for your application`}</li>
    </ul>
    <h2 {...{
      "id": "warning"
    }}>{`Warning`}</h2>
    <p>{`Paramount UI is considered unstable until version 2.x`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <p>{`Here is an example of using the library:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-ts"
      }}>{`import React from 'react';
import { ThemeProvider, Button } from 'paramount-ui';

const App = () => (
  <ThemeProvider>
    <Button color="primary" appearance="minimal" title="Hello World" />
  </ThemeProvider>
);
`}</code></pre>
    <h2 {...{
      "id": "getting-started"
    }}>{`Getting started`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`yarn add paramount-ui
# or
npm install --save paramount-ui
`}</code></pre>
    <h3 {...{
      "id": "setup-on-web"
    }}>{`Setup on Web`}</h3>
    <p><a parentName="p" {...{
        "href": "https://facebook.github.io/create-react-app/"
      }}>{`Create React App`}</a>{` works out of the box with `}<inlineCode parentName="p">{`paramount-ui`}</inlineCode>{`.`}</p>
    <p>{`For alternative setup, follow the guides on `}<a parentName="p" {...{
        "href": "https://github.com/necolas/react-native-web/blob/master/docs/guides/getting-started.md"
      }}>{`react-native-web`}</a></p>
    <h3 {...{
      "id": "setup-on-native"
    }}>{`Setup on Native`}</h3>
    <p><a parentName="p" {...{
        "href": "https://expo.io/"
      }}>{`Expo`}</a>{` works out of the box with `}<inlineCode parentName="p">{`paramount-ui`}</inlineCode></p>
    <p>{`If you do not have `}<inlineCode parentName="p">{`react-native-vector-icons`}</inlineCode>{` dependency in your setup, `}<a parentName="p" {...{
        "href": "https://github.com/oblador/react-native-vector-icons"
      }}>{`install it`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      